/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import EcgLoader from 'legacy/containers/EcgLoader';
import { Field, FieldArray, reduxForm, change, unregisterField } from 'redux-form'
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SelectField from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Link from '@material-ui/core/Link'
import Loading from '../../components/Loading'
import ValidationRules from '../../components/ValidationRules'
import { emailMask,
  requiredValidation,
  emailValidation,
  minLen1Validation,
  phoneValidationWith1Prefix,
} from '../../containers/Forms/components/formValidations'
import { checkTKFeatureEnabled } from '../../../configs'
import pluseIcon from 'static/images/Vector.png'

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

// constants for country and region
const countryList = [
  {
    name: 'United States',
    value: 'US',
  },
]

const RegionList = [
  { name: 'ALABAMA', value: 'AL' },
  { name: 'ALASKA', value: 'AK' },
  { name: 'AMERICAN SAMOA', value: 'AS' },
  { name: 'ARIZONA', value: 'AZ' },
  { name: 'ARKANSAS', value: 'AR' },
  { name: 'CALIFORNIA', value: 'CA' },
  { name: 'COLORADO', value: 'CO' },
  { name: 'CONNECTICUT', value: 'CT' },
  { name: 'DELAWARE', value: 'DE' },
  { name: 'DISTRICT OF COLUMBIA', value: 'DC' },
  { name: 'FEDERATED STATES OF MICRONESIA', value: 'FM' },
  { name: 'FLORIDA', value: 'FL' },
  { name: 'GEORGIA', value: 'GA' },
  { name: 'GUAM', value: 'GU' },
  { name: 'HAWAII', value: 'HI' },
  { name: 'IDAHO', value: 'ID' },
  { name: 'ILLINOIS', value: 'IL' },
  { name: 'INDIANA', value: 'IN' },
  { name: 'IOWA', value: 'IA' },
  { name: 'KANSAS', value: 'KS' },
  { name: 'KENTUCKY', value: 'KY' },
  { name: 'LOUISIANA', value: 'LA' },
  { name: 'MAINE', value: 'ME' },
  { name: 'MARSHALL ISLANDS', value: 'MH' },
  { name: 'MARYLAND', value: 'MD' },
  { name: 'MASSACHUSETTS', value: 'MA' },
  { name: 'MICHIGAN', value: 'MI' },
  { name: 'MINNESOTA', value: 'MN' },
  { name: 'MISSISSIPPI', value: 'MS' },
  { name: 'MISSOURI', value: 'MO' },
  { name: 'MONTANA', value: 'MT' },
  { name: 'NEBRASKA', value: 'NE' },
  { name: 'NEVADA', value: 'NV' },
  { name: 'NEW HAMPSHIRE', value: 'NH' },
  { name: 'NEW JERSEY', value: 'NJ' },
  { name: 'NEW MEXICO', value: 'NM' },
  { name: 'NEW YORK', value: 'NY' },
  { name: 'NORTH CAROLINA', value: 'NC' },
  { name: 'NORTH DAKOTA', value: 'ND' },
  { name: 'NORTHERN MARIANA ISLANDS', value: 'MP' },
  { name: 'OHIO', value: 'OH' },
  { name: 'OKLAHOMA', value: 'OK' },
  { name: 'OREGON', value: 'OR' },
  { name: 'PALAU', value: 'PW' },
  { name: 'PENNSYLVANIA', value: 'PA' },
  { name: 'PUERTO RICO', value: 'PR' },
  { name: 'RHODE ISLAND', value: 'RI' },
  { name: 'SOUTH CAROLINA', value: 'SC' },
  { name: 'SOUTH DAKOTA', value: 'SD' },
  { name: 'TENNESSEE', value: 'TN' },
  { name: 'TEXAS', value: 'TX' },
  { name: 'UTAH', value: 'UT' },
  { name: 'VERMONT', value: 'VT' },
  { name: 'VIRGIN ISLANDS', value: 'VI' },
  { name: 'VIRGINIA', value: 'VA' },
  { name: 'WASHINGTON', value: 'WA' },
  { name: 'WEST VIRGINIA', value: 'WV' },
  { name: 'WISCONSIN', value: 'WI' },
  { name: 'WYOMING', value: 'WY' },
]

const UpdatePasswordForm = props => {
  const dispatch = useDispatch();
  const notificationData = useSelector(state => state.app.dataSources.memberNotificationSettings);
  const memberData= useSelector(state => state.app.dataSources.memberNotificationSettings)
  const [appointmentNotification, setAppointmentNotification] = useState({
    isEmail: TKFeatureEnabled && notificationData && notificationData.data && notificationData.data.result ? notificationData.data.result.emailEnabled : false,
    isText: TKFeatureEnabled && notificationData && notificationData.data && notificationData.data.result ? notificationData.data.result.smsEnabled : false
  })
  const {
    handleSubmit,
    handleInputChange,
    handleNotificationChange,
    validationTests,
    invalid,
    pristine,
    isSubmitting,
    submitting,
    pwError,
    pwErrorMsg,
    me,
    getAppointmentNotificationsSettings,
    onInfoSubmit,
    getMemberInfo,
    memberOnChangeInfo,
    getMe,
  } = props;

  // Constants to check telekardia enabled and user is admin or not
  const TKFeatureEnabled = checkTKFeatureEnabled(me)
  const isAdminEnabled = me && me.data && me.data.profile.permissions.isAdmin


    // common array for all selected country and region. 
    let allCountryRegionArray = [];

    // getting values from counrty and region field from teh form.
    if(memberOnChangeInfo && memberOnChangeInfo.region){
      allCountryRegionArray.push({
        country: memberOnChangeInfo.country || '',
        region: memberOnChangeInfo.region
      })
    }
  
    // geeting values form the members array and combine to the allCountryRegionArray
    if (memberOnChangeInfo && memberOnChangeInfo.members && memberOnChangeInfo.members.length > 0 ){
      allCountryRegionArray =[...allCountryRegionArray, ...memberOnChangeInfo.members]
    }
  
    const RegionListRemoveSelected =  RegionList.filter(function(cv){
      return !allCountryRegionArray.find(function(er){
          return er.region == cv.value;
      });
  });

  useEffect(() => {
    if (TKFeatureEnabled) {
      getAppointmentNotificationsSettings()
      // !isAdminEnabled ? getMe() : ''
      getMemberInfo() // For getting member's data on my info page
    }
  }, [])

  useEffect(() => {
    if (TKFeatureEnabled && notificationData && notificationData.data && notificationData.data.result) {
      setAppointmentNotification({
        isEmail: notificationData.data.result.emailEnabled,
        isText: notificationData.data.result.smsEnabled,
      })
    }
  }, [notificationData])

  // Member info section implementation on My Info page
  const renderSelectField = withStyles({
    select: {
      height: '10px',
    },
  })(({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl size="small" variant="outlined">
      <InputLabel>{label}</InputLabel>
      <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        className={styles.selectFieldStyle}
        {...input}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        {...custom}
        />
        {error && <span className={styles.error}>{error}</span>}
    </FormControl>
  ))
 
  const renderMembers = temp => (
    <ul>
      <li className={ memberOnChangeInfo && memberOnChangeInfo.region === null && memberOnChangeInfo.country === null ? styles.displayNone : styles.editDropdown} >
        <div>
          <InputLabel className={styles.labelColorDropdown}>Country</InputLabel>
          <Field
            name="country"
            component={renderSelectField}
            disabled={!isAdminEnabled}
            validate={[ requiredValidation ]}
            //  label="Country"
          >
            {
              countryList.map((item, i) => <MenuItem key={i} value={item.value}>{item.name}</MenuItem>)
            }
          </Field> 
        </div>
        <div>
 
          <InputLabel className={styles.labelColorDropdown}>Region</InputLabel>
          <Field
            name="region"
            component={renderSelectField}
            disabled={!isAdminEnabled}
            validate={[ requiredValidation ]}
            //  label="Region"
          >
            {
              RegionList.map((item, i) => <MenuItem key={i}  disabled = {allCountryRegionArray.find(function(r){
                return (r.region == item.value ? true : false)
            })}   value={item.value}>{item.name}</MenuItem>)
            }
          </Field>
        </div>
        { isAdminEnabled ? <div style={{ marginTop: 34 }}>
        <Link href="#" style={{ marginLeft: 8 }} className={temp.fields.length === 0 ? styles.buttonVisibleMyinfo : styles.buttonCss} onClick={
          () => {
            dispatch(change('updatePasswordForm','region', null)); dispatch(change('updatePasswordForm','country', null))
          }
          }>
            Remove
            </Link>
          <img style={{ marginTop: -6 }} className={temp.fields.length === 0 ? styles.buttonCss : styles.buttonVisibleMyinfo} src={pluseIcon} alt="add button"/>
          <Link style={{ marginLeft: 8 }} href="#" className={temp.fields.length === 0 ? styles.buttonCss : styles.buttonVisibleMyinfo} onClick={() => temp.fields.push({})}>
           Add Location
          </Link>
        </div> : ''}
        {/* {submitFailed && error && <span>{error}</span>} */}
      </li>
      {temp.fields.map((member, index) => (
        <li className={styles.editDropdown} key={index}>
          <div>
            <InputLabel className={styles.labelColorDropdown}>Country</InputLabel>
            <Field
              name={`${member}.country`}
              component={renderSelectField}
              disabled={!isAdminEnabled}
              validate={[ requiredValidation ]}
              //  label="Country"
            >
              {
                countryList.map((item, i) => <MenuItem key={i} value={item.value}>{item.name}</MenuItem>)
              }
            </Field>
          </div>
          <div>
            <InputLabel className={styles.labelColorDropdown}>Region</InputLabel>
            <Field
              name={`${member}.region`}
              component={renderSelectField}
              disabled={!isAdminEnabled}
              validate={[ requiredValidation ]}
              //  label="Region"
            >
              {
                RegionList.map((item, i) => <MenuItem key={i}  disabled = {allCountryRegionArray.find(function(r){
                  return (r.region == item.value ? true : false)
              })}   value={item.value}>{item.name}</MenuItem>)
              }
            </Field>
          </div>
          {isAdminEnabled? <div style={{ marginTop: 34 }}>
          <Link href="#" style={{ marginLeft: 8 }} className={(temp.fields.length > 0) && (temp.fields.length === index) ? styles.buttonVisibleMyinfo : styles.buttonCss } onClick={() => temp.fields.remove(index)}>
            Remove
            </Link>
          </div> : ''}
        </li>))}
         {temp.fields.map((member, index) => (
        isAdminEnabled? <div style={{ marginTop: 14 }}>
        <img style={{ marginTop: -6 }} className={(temp.fields.length > 0) && (temp.fields.length - 1 === index) ? styles.buttonCss : styles.buttonVisibleMyinfo} src={pluseIcon} alt="add button"/>
        <Link href="#" style={{ marginLeft: 8 }} className={(temp.fields.length > 0) && (temp.fields.length - 1 === index) ? styles.buttonCss : styles.buttonVisibleMyinfo} onClick={() => temp.fields.push({})}>
       Add Location
        </Link>
      </div> : ''))}
      
    </ul>
  )

  return (
    <form onSubmit={handleSubmit}>
      {// me.isFetching ? <EcgLoader /> :
      <React.Fragment>
      {TKFeatureEnabled &&
      <React.Fragment>
      <h2 className={styles.formTitle}>Member Information</h2>
      <div className={styles.editMemberSection}>
         <div className={styles.formSectionRow}>
           <div className={styles.editLabelGroup}>
             <Field
               component={TextInput}
               label="First Name"
               name="firstName"
               placeholder="Enter First Name"
               required={true}
               validate={[ minLen1Validation, requiredValidation ]}
             />
           </div>
           <div className={styles.editLabelGroup}>
             <Field
               component={TextInput}
               label="Last Name"
               name="lastName"
               placeholder="Enter Last Name"
               required={true}
               validate={[ minLen1Validation, requiredValidation ]}
             />
           </div>
           <div className={styles.editLabelGroup}>
             <Field
               component={TextInput}
               label="Phone"
               name="phone"
               placeholder="Enter phone no"
               required={true}
               validate={[ requiredValidation, phoneValidationWith1Prefix ]}
             />
           </div>
           <div className={styles.editLabelGroup}>
             <Field
               component={MaskedInput}
               mask={emailMask}
               placeholder="name@example.com"
               label="Email"
               name="email"
               required={true}
               validate={[ emailValidation, minLen1Validation, requiredValidation ]}
             />
           </div>
         </div>
         <div style={{ marginTop: 15 }}>
           {/* <InputLabel>Country</InputLabel> */}
           <div className={styles.editDropdown}>
             <FieldArray name="members" component={renderMembers} />
           </div>
         </div>
       </div>
       <h2 className={styles.formTitle}>Member Roles</h2>
       <div className={styles.editMemberSection}>
         <div className={styles.formSectionRow}>
           <div style={{opacity: !isAdminEnabled? 0.4 : '', pointerEvents: !isAdminEnabled? 'none': ''}} className={styles.checkboxWithDesc}>
             <Field
               component={CheckboxInput}
               label="Provider"
               name="permissions.isPhysician"
             />
             <p style={{ marginBottom: 10 }} className={styles.description}>Access to Provider functions (e.g. Ordering Provider)</p>
           </div>
           <div style={{opacity: 0.4, pointerEvents: 'none'}} className={styles.checkboxWithDesc}>
             <Field
               component={CheckboxInput}
               label="Account Administrator"
               name="permissions.isAdmin"
             />
             <p className={styles.description}>Can manage team settings (e.g. add/remove members)</p>
           </div>
           <div className={styles.placeholder} />
         </div>
       </div>
          {/* Start Member Roles*/}
          {/* <h2 style={{ marginLeft: 0 }} className={styles.formTitle}>Member Roles</h2>
          <div className={styles.formSection}>
            <div className={styles.formSectionRow}>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  label="Provider"
                  name="isPhysician"
                />
                <p className={styles.description}>Access to Provider functions (e.g. Ordering Provider)</p>
              </div>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  label="Account Administrator"
                  name="isAdmin"
                />
                <p className={styles.description}>Can manage team settings (e.g. add/remove members)</p>
              </div>
              <div className={styles.placeholder} />
            </div>
          </div> */}
          {/* End Member Roles*/}

          {/* Start Appointment Notifications  */}
          <h2 style={{ marginLeft: 0 }} className={styles.formTitle}> Appointment Notifications</h2>
          <p className={styles.appointmentText}>Please choose the type of notification you would like to recieve for upcoming appointments</p>
          <div className={styles.formSection}>
            <div style={{ justifyContent: 'unset' }} className={styles.formSectionRow}>
              {(notificationData && notificationData.isFetching) ?
                <Loading />
                :
                <React.Fragment>
                  <div style={{ width: '10%' }} className={styles.checkboxWithDesc}>
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={appointmentNotification.isText}
                          onChange={(e) => { setAppointmentNotification({ ...appointmentNotification, isText: e.target.checked }) }} name="isText" />
                      }
                      label="Text"
                    />
                  </div>
                  <div className={styles.checkboxWithDesc}>
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={appointmentNotification.isEmail}
                          onChange={(e) => { setAppointmentNotification({ ...appointmentNotification, isEmail: e.target.checked }) }} name="isEmail" />
                      }
                      label="Email"
                    />
                  </div>
                  <div className={styles.placeholder} />
                </React.Fragment>
              }

            </div>
          </div>
          <div className={styles.appointmentbuttonWrapper}>
          {me.isFetching ?
            <button disabled className={styles.submitLoading}>
              <Loading />
            </button>
            :
            <button
              style={{ width: 'auto' }}
              className={styles.submit}
              onClick={() => { handleNotificationChange(appointmentNotification), onInfoSubmit(memberOnChangeInfo)}}>
              Save Changes
            </button>}
          </div>
        </React.Fragment>
      }
      <div className={styles.formSection}>
        <div className={styles.formSectionRowStacked}>
          <Field
            component={TextInput}
            name="currentPassword"
            label="Current password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
          <Field
            component={TextInput}
            name="newPassword"
            label="New password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
          <Field
            component={TextInput}
            name="newPasswordConfirm"
            label="Confirm new password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className={styles.validationRules}>
        <ValidationRules
          validationTests={validationTests}
          updatePassword={true}
        />
      </div>

      {
        pwError &&
        <div className={styles.pwValidationError}>{pwErrorMsg}</div>
      }

      <div className={styles.updatePwWrapper}>
        <div className={styles.buttonWrapper}>
          {submitting || isSubmitting ?
            <button
              disabled
              className={styles.submitLoading}
            >
              <Loading />
            </button>
            :
            <button
              type="submit"
              disabled={invalid || pristine}
              className={styles.submit}
            >
              Save
            </button>
          }
        </div>
      </div>
      </React.Fragment>}
    </form >
  )
}

export default reduxForm({
  form: 'updatePasswordForm',
  enableReinitialize: true,
})(UpdatePasswordForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/UpdatePasswordForm.jsx